<template>
  <div class="section center">
    <p class="mt-5 text l-700">
      <b data-aos="fade-up">Torturas</b>
      <br />
      <i data-aos="fade-up">Wislawa szymborska</i>
      <br />
      <span>/ / / / / /</span>
      <br />
      <br />
      <video
        autoplay
        loop
        class="img-moro"
        src="@/assets/images/torturas.mp4"
      ></video>
      <br />

      <span data-aos="fade-up">
        <br />
        <button
          v-if="audioPoemaPlaying"
          class="button-audio"
          @click="audioPoemaStop()"
        >
          <i class="bi bi-stop-circle"></i> Ouça o poema
        </button>
        <button v-else class="button-audio" @click="audioPoemaPlay()">
          <i class="bi bi-play-circle"></i> Ouça o poema
        </button>

        <span>Torturas</span><br />
        <span>Nada mudou.</span><br />
        <span>O corpo sente dor,</span><br />
        <span>necessita comer, respirar e dormir,</span><br />
        <span>tem a pele tenra e logo abaixo o sangue,</span><br />
        <span>uma boa reserva de de unhas e dentes,</span><br />
        <span>ossos frágeis, juntas alongáveis.</span><br />
        <span>Nas torturas leva-se tudo isso em conta.</span><br />
        <span>Nada mudou.</span><br />
        <span>Treme o corpo como tremia</span><br />
        <span>antes de se fundar Roma e depois de fundada,</span><br />
        <span>no século XX antes e depois de Cristo,</span><br />
        <span>as torturas são como eram, só a terra encolheu</span><br />
        <span>e o que quer que se passe parece ser na porta ao lado.</span
        ><br />
        <span>…</span><br />
      </span>

      <span data-aos="fade-up">
        <span>Nada mudou.</span><br />
        <span>Talvez os modos, as cerimônias, as danças.</span><br />
        <span>O gesto da mão protegendo o rosto,</span><br />
        <span>esse permanece o mesmo.</span><br />
        <span>O corpo se enrosca, se debate, se contorce</span><br />
        <span>cai se lhe falta o chão, encolhe as pernas,</span><br />
        <span>fica roxo, incha, baba e sangra.</span><br />
        <span>Nada mudou.</span><br />
      </span>

      <br />

      <span data-aos="fade-up">
        <span>Além do curso dos rios,</span><br />
        <span>do contorno das costas, matas, desertos e geleiras.</span><br />
        <span>Entre essas paisagens a pequena alma passeia,</span><br />
        <span>some, volta, chega perto, voa longe,</span><br />
        <span>estranha a si própria, inatingível,</span><br />
        <span>ora certa, ora incerta da sua existência,</span><br />
        <span>enquanto o corpo é, é, é</span><br />
        <span>e não tem para onde ir.</span><br />
        <br />

        <i>(TRADUÇÃO: Regina Przybycien)</i>
      </span>
    </p>
  </div>
</template>

<script>
import audios from "@/mixins/audios.js";
export default {
  mixins: [audios],
  computed: {
    soundState() {
      return this.$store.state.soundState;
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  min-height: 100vh;
}

.text-orange {
  margin-top: 60px;
  background-color: #dc793a;
  color: white;
  font-family: Roboto Mono;
  padding: 2px 2px 0px 2px;
  font-size: 1.5rem;
  font-weight: 300;
}
</style>